export const headerCustomParameterType = {
  displayName: "DISPLAY_NAME",
  appName: "APP_NAME",
  points: "POINTS",
  cash: "CASH",
  levelName: "LEVEL_NAME",
};

/**
 * headerConfigurableType
 * 1. greetingWithName: 2 rows, first row show greeting wordings, second row show customer name
 * 2. logo: have another extra config "headerLogoCenter", options: "true/false", default is false
 * and have config "showPointToCashBanner", options: "true/false", default is true
 * 3. welcomeMessage: 1 or 2 rows, have extra config "headerFirstMessage" and "headerSecondMessage".
 * They are the keys of wordings.
 * 4. pointWithCash: 2 rows, first row show point title and cash title,
 * second row show customer owned points and cash that could be convert.
 * point and cash are separated with "=".
 * 5. custom: 2 rows, first row show wordings defined in wording list, second row show custom property.
 * have extra config "headerCustomWording" and "headerCustomParameter"
 * 6. none: no left header
 */
export const headerConfigurableType = {
  greetingWithName: "GREETING_WITH_NAME",
  logo: "LOGO",
  welcomeMessage: "WELCOME_MESSAGE",
  pointWithCash: "POINT_WITH_CASH",
  custom: "CUSTOM",
  none: "NONE"
};

export const defaultHeaderConfig = {
  type: headerConfigurableType.logo,
  headerLogoCenter: false,
  showPointToCashBanner: false,
  webShowSections: true,
  webShowLanguage: false,
  webShowSideMenu: false,
  mobileShowLanguage: false,
}


// add extra config, example:
// export const headerConfig = [
//   {
//     pathname: "/home",
//     type: headerConfigurableType.pointWithCash,
//     webShowSections: true,
//     webShowLanguage: true,
//     webShowSideMenu: false,
//     mobileShowLanguage: true,
//   }
// ]

export const headerConfig = [];
